import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import type { RootState } from './store';
import { VisualizationSpec } from 'react-vega';
import { Entity } from '@backstage/catalog-model';

export interface IntegrationsExplorerState {
  selectedTab: number;
  activeConsumer: string | null;
  selectedEntity: any | null;
  activeChart: string;
  baseSpec: VisualizationSpec | null;
  defaultLeftSpec: VisualizationSpec | null;
  defaultRightSpec: VisualizationSpec | null;
  detailLeftSpec: VisualizationSpec | null;
  detailRightSpec: VisualizationSpec | null;
  leftCurrentSpec: VisualizationSpec | null;
  rightCurrentSpec: VisualizationSpec | null;
  activeData: string;
  baseData: null | { left: Array<any>; right: Array<any> };
  chartFilteredEntities: Entity[] | null;
}

const initialState: IntegrationsExplorerState = {
  selectedTab: 0,
  activeConsumer: null,
  selectedEntity: null,
  activeChart: '',
  baseSpec: null,
  defaultLeftSpec: null,
  defaultRightSpec: null,
  detailLeftSpec: null,
  detailRightSpec: null,
  leftCurrentSpec: null,
  rightCurrentSpec: null,
  activeData: '',
  baseData: null,
  chartFilteredEntities: null,
};

export const integrationsExplorerSlice = createSlice({
  name: 'integrationsExplorer',
  initialState,
  reducers: {
    setSelectedTab: (state, action: PayloadAction<number>) => {
      state.selectedTab = action.payload;
    },
    setActiveConsumer: (state, action: PayloadAction<string | null>) => {
      state.activeConsumer = action.payload;
    },
    setSelectedEntity: (state, action: PayloadAction<any | null>) => {
      state.selectedEntity = action.payload;
    },
    setActiveChart: (state, action: PayloadAction<string>) => {
      state.activeChart = action.payload;
    },
    setBaseSpec: (state, action: PayloadAction<VisualizationSpec>) => {
      state.baseSpec = action.payload;
    },
    setDefaultLeftSpec: (state, action: PayloadAction<VisualizationSpec>) => {
      state.defaultLeftSpec = action.payload;
    },
    setDefaultRightSpec: (state, action: PayloadAction<VisualizationSpec>) => {
      state.defaultRightSpec = action.payload;
    },
    setDetailLeftSpec: (state, action: PayloadAction<VisualizationSpec>) => {
      state.detailLeftSpec = action.payload;
    },
    setDetailRightSpec: (state, action: PayloadAction<VisualizationSpec>) => {
      state.detailRightSpec = action.payload;
    },
    setLeftCurrentSpec: (state, action: PayloadAction<VisualizationSpec>) => {
      state.leftCurrentSpec = action.payload;
    },
    setRightCurrentSpec: (state, action: PayloadAction<VisualizationSpec>) => {
      state.rightCurrentSpec = action.payload;
    },
    setActiveData: (state, action: PayloadAction<string>) => {
      state.activeData = action.payload;
    },
    setBaseData: (state, action: PayloadAction<{ left: any; right: any }>) => {
      state.baseData = action.payload;
    },
    setChartFilteredEntities: (state, action: PayloadAction<Entity[] | null>) => { 
      state.chartFilteredEntities = action.payload;
    },
  },
});

export const {
  setSelectedTab,
  setActiveConsumer,
  setSelectedEntity,
  setActiveChart,
  setBaseSpec,
  setDefaultLeftSpec,
  setDefaultRightSpec,
  setDetailLeftSpec,
  setDetailRightSpec,
  setLeftCurrentSpec,
  setRightCurrentSpec,
  setActiveData,
  setBaseData,
  setChartFilteredEntities,
} = integrationsExplorerSlice.actions;

export const selectIntegrationsExplorerState = (state: RootState) =>
  state.integrationsExplorer;

export default integrationsExplorerSlice.reducer;
